import { entrySplitApi as api } from "../entryApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    contentsControllerCreate: build.mutation<
      ContentsControllerCreateApiResponse,
      ContentsControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/contents`,
        method: "POST",
        body: queryArg.createContentDto,
      }),
    }),
    contentsControllerList: build.query<
      ContentsControllerListApiResponse,
      ContentsControllerListApiArg
    >({
      query: (queryArg) => ({
        url: `/contents/a-list`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          orderBy: queryArg.orderBy,
          sortOrder: queryArg.sortOrder,
          keyword: queryArg.keyword,
          lang: queryArg.lang,
          key: queryArg.key,
          title: queryArg.title,
          type: queryArg["type"],
        },
      }),
    }),
    contentsControllerGetArticles: build.query<
      ContentsControllerGetArticlesApiResponse,
      ContentsControllerGetArticlesApiArg
    >({
      query: (queryArg) => ({
        url: `/contents/articles`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          orderBy: queryArg.orderBy,
          sortOrder: queryArg.sortOrder,
          keyword: queryArg.keyword,
          lang: queryArg.lang,
          key: queryArg.key,
          title: queryArg.title,
          type: queryArg["type"],
        },
      }),
    }),
    contentsControllerFindArticle: build.query<
      ContentsControllerFindArticleApiResponse,
      ContentsControllerFindArticleApiArg
    >({
      query: (queryArg) => ({
        url: `/contents/article/${queryArg.lang}/${queryArg.id}`,
      }),
    }),
    contentsControllerFindByKey: build.query<
      ContentsControllerFindByKeyApiResponse,
      ContentsControllerFindByKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/contents/byKey/${queryArg.lang}/${queryArg.key}`,
      }),
    }),
    contentsControllerFindById: build.query<
      ContentsControllerFindByIdApiResponse,
      ContentsControllerFindByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/contents/byId/${queryArg.lang}/${queryArg.id}`,
      }),
    }),
    contentsControllerUpdateSort: build.mutation<
      ContentsControllerUpdateSortApiResponse,
      ContentsControllerUpdateSortApiArg
    >({
      query: (queryArg) => ({
        url: `/contents/sort/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.updateContentDto,
      }),
    }),
    contentsControllerUpdatePinned: build.mutation<
      ContentsControllerUpdatePinnedApiResponse,
      ContentsControllerUpdatePinnedApiArg
    >({
      query: (queryArg) => ({
        url: `/contents/pinned/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.updateContentDto,
      }),
    }),
    contentsControllerUpdatePublic: build.mutation<
      ContentsControllerUpdatePublicApiResponse,
      ContentsControllerUpdatePublicApiArg
    >({
      query: (queryArg) => ({
        url: `/contents/public/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.updateContentDto,
      }),
    }),
    contentsControllerUpdateArticle: build.mutation<
      ContentsControllerUpdateArticleApiResponse,
      ContentsControllerUpdateArticleApiArg
    >({
      query: (queryArg) => ({
        url: `/contents/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.createContentDto,
      }),
    }),
    contentsControllerRemove: build.mutation<
      ContentsControllerRemoveApiResponse,
      ContentsControllerRemoveApiArg
    >({
      query: (queryArg) => ({
        url: `/contents/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as combinedApi };
export type ContentsControllerCreateApiResponse = unknown;
export type ContentsControllerCreateApiArg = {
  createContentDto: CreateContentDto;
};
export type ContentsControllerListApiResponse = /** status 200  */ {
  data?: AdminContentDto[];
} & {
  meta?: {
    total?: number;
    lastPage?: number;
    currentPage?: number;
    perPage?: number;
    prev?: number;
    next?: number;
  };
};
export type ContentsControllerListApiArg = {
  page: number;
  pageSize: number;
  orderBy?: string;
  sortOrder?: "ASC" | "DESC";
  keyword?: string;
  lang?: LanguageType;
  key?: string;
  title?: string;
  type?: ContentType;
};
export type ContentsControllerGetArticlesApiResponse = /** status 200  */ {
  data?: ContentDto[];
} & {
  meta?: {
    total?: number;
    lastPage?: number;
    currentPage?: number;
    perPage?: number;
    prev?: number;
    next?: number;
  };
};
export type ContentsControllerGetArticlesApiArg = {
  page: number;
  pageSize: number;
  orderBy?: string;
  sortOrder?: "ASC" | "DESC";
  keyword?: string;
  lang?: LanguageType;
  key?: string;
  title?: string;
  type?: ContentType;
};
export type ContentsControllerFindArticleApiResponse =
  /** status 200  */ ContentDto;
export type ContentsControllerFindArticleApiArg = {
  id: string;
  lang: string;
};
export type ContentsControllerFindByKeyApiResponse =
  /** status 200  */ ContentDto;
export type ContentsControllerFindByKeyApiArg = {
  key: string;
  lang: string;
};
export type ContentsControllerFindByIdApiResponse =
  /** status 200  */ AdminContentDto;
export type ContentsControllerFindByIdApiArg = {
  id: string;
  lang: string;
};
export type ContentsControllerUpdateSortApiResponse = unknown;
export type ContentsControllerUpdateSortApiArg = {
  id: string;
  updateContentDto: UpdateContentDto;
};
export type ContentsControllerUpdatePinnedApiResponse = unknown;
export type ContentsControllerUpdatePinnedApiArg = {
  id: string;
  updateContentDto: UpdateContentDto;
};
export type ContentsControllerUpdatePublicApiResponse = unknown;
export type ContentsControllerUpdatePublicApiArg = {
  id: string;
  updateContentDto: UpdateContentDto;
};
export type ContentsControllerUpdateArticleApiResponse = unknown;
export type ContentsControllerUpdateArticleApiArg = {
  id: string;
  createContentDto: CreateContentDto;
};
export type ContentsControllerRemoveApiResponse = unknown;
export type ContentsControllerRemoveApiArg = {
  id: string;
};
export type ContentType = "article" | "page";
export type CreateContentDto = {
  type: ContentType;
  key?: string;
  sort?: number;
  cntTitle: string;
  cntDescription: string;
  cntContent: object;
  cnTitle?: string;
  cnDescription?: string;
  cnContent?: object;
  enTitle?: string;
  enDescription?: string;
  enContent?: object;
  icon?: string;
  createdById?: string;
  isPublic?: boolean;
  isDisplay?: boolean;
  pinned?: boolean;
};
export type LanguageType = "en" | "cn" | "cnt";
export type QuestionScoreByTypeDto = {
  decisive: number;
  analytical: number;
  creative: number;
  idealistic: number;
  controlling: number;
  affairs: number;
  feel: number;
  interpersonal: number;
};
export type UserDto = {
  id: string;
  name: string;
  username: string;
  firstName?: string;
  lastName?: string;
  alias?: string;
  mobile?: string;
  defaultLanguage: LanguageType;
  recordsCount?: number;
  averageScore?: QuestionScoreByTypeDto;
  isSuperAdmin?: boolean;
  role?: string;
  roleId?: string;
  roleExpiredBy?: string;
  createdAt: string;
  updatedAt: string;
};
export type AdminContentDto = {
  id: string;
  type: ContentType;
  key: string;
  cntTitle: string;
  cntDescription: string;
  cntContent?: object;
  cnTitle: string;
  cnDescription: string;
  cnContent?: object;
  enTitle: string;
  enDescription: string;
  enContent?: object;
  icon?: string;
  sort: number;
  readCount: number;
  isPublic: boolean;
  pinned: boolean;
  createdAt: string;
  updatedAt: string;
  createdBy?: UserDto;
};
export type ContentDataDto = {
  version?: string;
  time?: number;
  blocks: string[];
};
export type ContentDto = {
  id: string;
  type: ContentType;
  key: string;
  title: string;
  description: string;
  content?: ContentDataDto;
  icon?: string;
  sort: number;
  isPublic: boolean;
  pinned: boolean;
  count: number;
  createdAt: string;
  updatedAt: string;
  createdBy?: UserDto;
};
export type UpdateContentDto = {
  sort?: number;
  pinned?: boolean;
  isPublic?: boolean;
};
export const {
  useContentsControllerCreateMutation,
  useContentsControllerListQuery,
  useLazyContentsControllerListQuery,
  useContentsControllerGetArticlesQuery,
  useLazyContentsControllerGetArticlesQuery,
  useContentsControllerFindArticleQuery,
  useLazyContentsControllerFindArticleQuery,
  useContentsControllerFindByKeyQuery,
  useLazyContentsControllerFindByKeyQuery,
  useContentsControllerFindByIdQuery,
  useLazyContentsControllerFindByIdQuery,
  useContentsControllerUpdateSortMutation,
  useContentsControllerUpdatePinnedMutation,
  useContentsControllerUpdatePublicMutation,
  useContentsControllerUpdateArticleMutation,
  useContentsControllerRemoveMutation,
} = injectedRtkApi;
